module.exports = __webpack_public_path__ + "static/img/dd-target-icon-03.265c74d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-target-icon-03.png
// module id = OIfg
// module chunks = 1